import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Col, Row } from 'reactstrap';
import Spinners from 'components/Common/Spinner';
import Paginations from 'components/Common/Pagination';
import BookingCard from './BookingCard';
import { useDispatch } from 'react-redux';
import { setBookingFilters, setBookingsViewType, setSelectedBooking } from 'store/actions';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import BookingList from './BookingList';

const BookingGrid = props => {
	const [isLoading, setLoading] = useState(props.isLoading);
	// pagination
	const [jobData, setJobData] = useState();
	const [currentPage, setCurrentPage] = useState(1);
	const perPageData = 100;

	const dispatch = useDispatch();

	const FiltersProperties = createSelector(
		state => state.BookingFilters,
		filters => ({
			selectedBooking: filters.selectedBookingId,
			bookingViewType: filters.bookingViewType
		})
	);

	const { selectedBooking, bookingViewType } = useSelector(FiltersProperties);

	useEffect(() => {
		const indexOfLast = currentPage * perPageData;
		const indexOfFirst = indexOfLast - perPageData;
		let data = props.bookingsData?.statusData?.slice(indexOfFirst, indexOfLast);
		setJobData(data);

		setTimeout(() => {
			const element = document.getElementById(selectedBooking);
			if (element) {
				element?.scrollIntoView({
					behavior: 'smooth'
				});
			}
		}, 4000);
	}, [props.bookingsData]);
	// validation

	return (
		<React.Fragment>
			{isLoading ? (
				<Spinners setLoading={setLoading} />
			) : (
				<>
					{!props.isFilterModelOpen ? (
						<Row className="mb-3 ">
							<Col xl={8}>
								{(props.selectedFilters || []).map((item, key) => (
									<span
										className="btn btn-primary mt-1 py-1 px-3 me-2 font-size-10"
										onClick={() => {
											if (item.canremove) {
												let previousFilters = props.selectedFilters;
												previousFilters.splice(key, 1);
												//	props.setSelectedFilters([...previousFilters]);
												dispatch(setBookingFilters([...previousFilters]));
											}
											if (item.name === 'Month') {
												props.setIsFilterModelOpen(true);
											}
										}}
										key={key}
									>
										<i className={item.icon}></i> {item.name} : {item.label}{' '}
										{item.canremove && <i className="mdi mdi-close ms-2"></i>}
									</span>
								))}
							</Col>
							<Col xl={4} className="text-end justify-content-end">
								<span
									className="btn btn-primary py-1 px-3 me-2 font-size-10"
									onClick={() => props.setIsFilterModelOpen(true)}
								>
									<i className="mdi mdi-filter-variant me-2"></i>
									{props.t('Filter')}
								</span>
								<span
									className={
										bookingViewType != 'grid'
											? 'btn btn-primary py-1 px-3 me-2 font-size-10'
											: 'btn btn-secondary py-1 px-3 me-2 font-size-10'
									}
									onClick={() => dispatch(setBookingsViewType('grid'))}
								>
									<i className="mdi mdi-view-grid-outline me-2"></i> {props.t('Grid')}
								</span>
								<span
									className={
										bookingViewType != 'list'
											? 'btn btn-primary py-1 px-3 me-2 font-size-10'
											: 'btn btn-secondary py-1 px-3 me-2 font-size-10'
									}
									onClick={() => dispatch(setBookingsViewType('list'))}
								>
									<i className="mdi mdi-format-list-numbered me-2"></i> {props.t('List')}
								</span>
							</Col>
						</Row>
					) : null}

					<Row>
						{bookingViewType == 'grid' ? (
							(jobData || []).map((item, key) => (
								<Col xl={6} lg={6} sm={12} key={key} id={item._id}>
									<BookingCard
										bookingData={item}
										selectedBookingId={selectedBooking}
										internalUsersList={props.internalUsersList}
									/>
								</Col>
							))
						) : (
							<BookingList
								bookingList={jobData}
								selectedBookingId={selectedBooking}
								internalUsersList={props.internalUsersList}
							/>
						)}
					</Row>
					<Paginations
						perPageData={
							props.bookingsData?.statusData?.length < perPageData
								? props.bookingsData?.statusData?.length
								: perPageData
						}
						dataLength={props.bookingsData?.statusData?.length}
						currentPage={currentPage}
						setCurrentPage={setCurrentPage}
						isShowingPageLength={true}
						paginationDiv="col-sm-12 col-md-7"
						paginationClass="pagination justify-content-end pagination-rounded"
					/>
				</>
			)}
		</React.Fragment>
	);
};

export default BookingGrid;
